import {IdentityProfile} from '../components/IdentityProfile';
import {AboutProfile} from '../components/AboutProfile';
import {ContactProfile} from '../components/ContactProfile';
import {
    FormPageLayout,
} from '@flexinet/ui-components';
import {Anchor, Avatar, Card, Group, Progress, Stack, Text, Title} from '@mantine/core';
import {useUserAttributes} from '../../../../hooks/useUserAttributes';
import {useUserProfileAttributes} from '../hooks/useUserProfileAttributes';
import {Link} from 'react-router-dom';


export const IndexPage = () => {

    const {givenName, familyName, email} = useUserAttributes();
    const {
        phoneNumber,
        address,
        website,
        locale,
        zoneInfo,
        nickname,
        gender,
        birthDate,
        profile: profileUrl,
        picture,
    } = useUserProfileAttributes();

    const displayName = [givenName, familyName].filter(Boolean).join(' ') || email;
    const initials = givenName && familyName
        ? `${givenName[0]}${familyName[0]}`.toUpperCase()
        : email?.[0]?.toUpperCase() || '?';

    const optionalFields = [phoneNumber, address, website, locale, zoneInfo, nickname, gender, birthDate, profileUrl, picture];
    const filledCount = optionalFields.filter(Boolean).length;
    const completionPct = Math.round((filledCount / optionalFields.length) * 100);

    return (
        <FormPageLayout title="Personal Info" tools={[]}>
            <Stack gap="lg">
                <Text c="dimmed" size="sm">
                    Your name, contact details, and personal preferences. This information is
                    visible to you and used for communication.
                </Text>

                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <Group wrap="nowrap" gap="lg">
                        <Avatar
                            size="xl"
                            radius="xl"
                            color="blue"
                            src={picture || null}
                            alt={`${displayName} avatar`}
                            aria-label="User avatar"
                        >
                            {initials}
                        </Avatar>
                        <Stack gap={4} style={{flex: 1}}>
                            <Title order={3}>{displayName}</Title>
                            {displayName !== email && (
                                <Text size="sm" c="dimmed">{email}</Text>
                            )}
                            {completionPct < 100 && (
                                <Group gap="xs" mt="xs">
                                    <Progress
                                        value={completionPct}
                                        size="sm"
                                        radius="xl"
                                        style={{flex: 1}}
                                        color={completionPct >= 70 ? 'teal' : 'blue'}
                                        aria-label={`Profile ${completionPct}% complete`}
                                    />
                                    <Text size="xs" c="dimmed">{completionPct}%</Text>
                                </Group>
                            )}
                        </Stack>
                    </Group>
                </Card>

                <IdentityProfile/>
                <ContactProfile/>
                <AboutProfile/>

                <Text size="xs" c="dimmed" ta="center" mt="md">
                    Looking for your account ID, status, or billing setup?{' '}
                    <Anchor component={Link} to="/account/" size="xs">
                        Go to Account & Billing
                    </Anchor>
                </Text>
            </Stack>
        </FormPageLayout>
    );
};
